import { render, staticRenderFns } from "./InsolvencyPractitionerTask.vue?vue&type=template&id=5356eaab&scoped=true&"
import script from "./InsolvencyPractitionerTask.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPractitionerTask.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPractitionerTask.vue?vue&type=style&index=0&id=5356eaab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356eaab",
  null
  
)

export default component.exports